type Props = {
  width?: string;
  height?: string;
  strokeColor?: string;
};
/**
 * TimelineEndCardIcon — a frame with a solid bar on its RIGHT edge: the card
 * that closes the video. Pairs with `TimelineIntroCardIcon` (bar on the left).
 */
const TimelineEndCardIcon = ({
  width = '14',
  height = '14',
  strokeColor = 'currentColor',
}: Props) => (
  <svg width={width} height={height} viewBox="0 0 14 14" fill="none">
    <rect
      x="1.5"
      y="2.5"
      width="11"
      height="9"
      rx="1.5"
      stroke={strokeColor}
      strokeWidth="1"
    />
    <rect x="9.5" y="2.5" width="3" height="9" rx="1" fill={strokeColor} />
  </svg>
);

export default TimelineEndCardIcon;
